// Import the functions you need from the SDKs you need
import { initializeApp, type FirebaseApp } from 'firebase/app';
import {
  getAuth,
  type Auth,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset
} from 'firebase/auth';

// Firebase configuration interface
interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

// Your web app's Firebase configuration
const firebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyDINJMGYeBZlMwP1fXnTmGwrcFbdms9m18",
  authDomain: "neurosedge.firebaseapp.com",
  projectId: "neurosedge",
  storageBucket: "neurosedge.firebasestorage.app",
  messagingSenderId: "394149069208",
  appId: "1:394149069208:web:61ab63bd1ce992c1ea2bed",
  measurementId: "G-31FS7Y63J4"
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth: Auth = getAuth(app);

// Export password reset functions for easy import
export {
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset
};

// Export the app for other uses if needed
export default app;
